import { create } from 'zustand';

interface CustomerCardState {
  open: boolean;
  number: string | null;
  /** מסך שמציג את הכרטיס מוטמע מדליק זאת, כדי שהעותק הצף לא יכסה אותו. */
  suppressFloating: boolean;
  /** Numbers whose wrap-up the agent already filled (disposition picked) during
   *  this session — so the blocking WrapupOverlay doesn't pop again at hangup. */
  summarized: Record<string, boolean>;
  /** Pop the card for a number (outbound dial or answered inbound). */
  show: (number: string) => void;
  close: () => void;
  setSuppressFloating: (v: boolean) => void;
  /** Mark that a summary/disposition was filled for this number. */
  markSummarized: (number: string) => void;
  isSummarized: (number: string | null) => boolean;
}

const tail = (n: string | null) => (n ? n.replace(/[^0-9]/g, '').slice(-9) : '');

/**
 * Controls the floating customer card. Opened automatically by the SIP store
 * when a call becomes active (see AgentLayout's auto-pop effect), and closeable
 * by the agent. Keyed on the counterparty number.
 */
export const useCustomerCard = create<CustomerCardState>((set, get) => ({
  open: false,
  number: null,
  // מסך שמציג את הכרטיס בעצמו (מסך העבודה על קמפיין) מדליק את הדגל הזה,
  // כדי שהעותק הצף לא יופיע מעליו. הדגל נוגע **רק בתצוגה** — הטעינה
  // והשמירה של הכרטיס המוטמע ממשיכות כרגיל.
  suppressFloating: false,
  summarized: {},
  show: (number) => set({ open: true, number }),
  close: () => set({ open: false }),
  setSuppressFloating: (v) => set({ suppressFloating: v }),
  markSummarized: (number) => set((s) => ({ summarized: { ...s.summarized, [tail(number)]: true } })),
  isSummarized: (number) => !!get().summarized[tail(number)],
}));
